import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Success from "./pages/Success";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/success" element={<Success />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#FAF9F6",
            color: "#1A1A1A",
            border: "1px solid rgba(26,26,26,0.1)",
            borderRadius: "0",
            fontFamily: "Manrope, sans-serif",
            letterSpacing: "0.05em",
          },
        }}
      />
    </div>
  );
}

export default App;
